import React from "react";

const PurchaseProfileBuyerAgentDesc = (data) => {
const cmsData = data?.data
  return (
    <div
      className="cif-buyer-consent"
    >
      <div id="cif_accordion">
        {cmsData?.buyerAgentDesc1}
      </div>
      <div id="cif_accordion">
      {cmsData?.buyerAgentDesc2}
      </div>
    </div>
  );
};

export default PurchaseProfileBuyerAgentDesc;
